(() => {
  // prevent double init (Shopify иногда может подхватить код 2 раза)
  if (window.__AE_WIDGET_INIT_V1) return;
  window.__AE_WIDGET_INIT_V1 = true;

  const $ = (sel, root=document) => root.querySelector(sel);
  const $$ = (sel, root=document) => Array.from(root.querySelectorAll(sel));

  const widget = $("#ae-widget");
  const fab = $("#ae-fab");
  const panel = $("#ae-panel");
  const dim = $("#ae-dim");
  const closeBtn = $("#ae-close");
  const resetBtn = $("#ae-reset");

  const langBtn = $("#ae-lang");
  const langMenu = $("#ae-lang-menu");
  const langCode = $("#ae-lang-code");

  const tooltip = $("#ae-tooltip");

  const modal = $("#ae-modal");
  const modalClose = $("#ae-modal-close");
  const modalList = $("#ae-modal-list");

  const KEY = "ae_widget_state_v3";
  if (!widget || !fab || !panel) return;

  // ---------- i18n ----------
  const i18n = {
    de: {
      title: "Spezielle Möglichkeiten",
      select_language: "Sprache wählen",
      profiles: "Profile",

      sec_display: "Anzeige & Layout",
      sec_reading: "Lesen & Inhalt",
      sec_nav: "Navigation & Interaktion",

      contrast: "Kontrast",
      grayscale: "Graustufen",
      invert: "Farben invertieren",
      brightness: "Helligkeit",
      saturation: "Sättigung",
      highlight_links: "Links hervorheben",
      pause_anim: "Animationen pausieren",
      hide_images: "Bilder ausblenden",
      mute: "Ton stummschalten",

      bigger_text: "Größerer Text",
      text_spacing: "Zeichenabstand",
      line_spacing: "Zeilenabstand",
      text_align: "Textausrichtung",
      dyslexia_friendly: "Dyslexie-freundlich",
      bionic: "Bionic Reading",

      highlight_headings: "Überschriften hervorheben",
      page_structure: "Seitenstruktur",
      big_cursor: "Großer Cursor",
      tooltips: "Tooltips",

      reset: "Zurücksetzen",

      tab_headings: "Überschriften",
      tab_landmarks: "Landmarks",
      tab_links: "Links",

      profile_vision: "Sehbeeinträchtigung",
      profile_seizure: "Anfallsschutz",
      profile_dyslexia: "Dyslexie",
      profile_adhd: "ADHS-freundlich",
      profile_cognitive: "Kognitiv",

      tt_title: "Info",
      tt_label: "label",
      tt_tag: "element",
    },
    en: {
      title: "Special Options",
      select_language: "Select Language",
      profiles: "Accessibility Profiles",

      sec_display: "Display & Layout",
      sec_reading: "Reading & Content",
      sec_nav: "Navigation & Interaction",

      contrast: "Contrast",
      grayscale: "Grayscale",
      invert: "Inverted Colors",
      brightness: "Brightness",
      saturation: "Saturation",
      highlight_links: "Highlight Links",
      pause_anim: "Pause Animations",
      hide_images: "Hide Images",
      mute: "Mute Sounds",

      bigger_text: "Bigger Text",
      text_spacing: "Text Spacing",
      line_spacing: "Line Spacing",
      text_align: "Text Alignment",
      dyslexia_friendly: "Dyslexia Friendly",
      bionic: "Bionic Reading",

      highlight_headings: "Highlight Headings",
      page_structure: "Page Structure",
      big_cursor: "Big Cursor",
      tooltips: "Tooltips",

      reset: "Reset",

      tab_headings: "Headings",
      tab_landmarks: "Landmarks",
      tab_links: "Links",

      profile_vision: "Vision Impaired",
      profile_seizure: "Seizure",
      profile_dyslexia: "Dyslexia",
      profile_adhd: "ADHD Friendly",
      profile_cognitive: "Cognitive",

      tt_title: "Info",
      tt_label: "label",
      tt_tag: "element",
    }
  };

  function detectLang(){
    const docLang = (document.documentElement.getAttribute("lang") || "").toLowerCase();
    return docLang.startsWith("de") ? "de" : "en";
  }

  function applyI18n(lang){
    if (langCode) langCode.textContent = lang.toUpperCase();
    $$("[data-i18n]").forEach(el => {
      const key = el.getAttribute("data-i18n");
      const val = (i18n[lang] && i18n[lang][key]) ? i18n[lang][key] : null;
      if (val) el.textContent = val;
    });
  }

  // ---------- state ----------
  const defaultState = {
    lang: detectLang(),
    activeProfile: null,
    baseline: null, // IMPORTANT: теперь baseline будем сохранять в localStorage

    contrast: 0,
    grayscale: false,
    invert: false,
    brightness: 0,
    saturation: 0,
    highlightLinks: false,
    pauseAnimations: false,
    hideImages: false,
    muteSounds: false,

    biggerText: 0,
    textSpacing: 0,
    lineSpacing: 0,
    textAlign: 0,
    dyslexiaFont: false,
    bionicReading: false,

    highlightHeadings: false,
    bigCursor: false,
    tooltips: false,
  };

  function loadState(){
    try{
      const raw = localStorage.getItem(KEY);
      if(!raw) return {...defaultState};
      const parsed = JSON.parse(raw) || {};
      // baseline может быть объектом (сохранённым)
      return {...defaultState, ...parsed};
    }catch(e){
      return {...defaultState};
    }
  }

  let state = loadState();

  function saveState(){
    try{
      localStorage.setItem(KEY, JSON.stringify(state));
    }catch(e){}
  }

  // ---------- helpers ----------
  function setPressed(btn, pressed){
    if(!btn) return;
    btn.classList.toggle("is-active", !!pressed);
    btn.setAttribute("aria-pressed", pressed ? "true" : "false");
  }

  function ensureBars(){
    $$("[data-bars]").forEach(wrap=>{
      const count = parseInt(wrap.getAttribute("data-bars-count") || "3", 10);
      if (wrap.children.length === count) return;
      wrap.innerHTML = "";
      for(let i=0;i<count;i++) wrap.appendChild(document.createElement("span"));
    });
  }

  function setBars(name, level){
    const wrap = $(`.ae-bars[data-bars="${name}"]`);
    if(!wrap) return;
    const spans = $$("span", wrap);
    const n = spans.length;
    const on = Math.max(0, Math.min(level, n));
    spans.forEach((s,i)=> s.classList.toggle("is-on", i < on));
  }

  // ---------- apply effects ----------
  function applyFilters(){
    const filters = [];
    if (state.grayscale) filters.push("grayscale(1)");
    if (state.invert) filters.push("invert(1) hue-rotate(180deg)");

    if (state.contrast === 1) filters.push("contrast(0.85)");
    if (state.contrast === 2) filters.push("contrast(1.35)");

    if (state.brightness === 1) filters.push("brightness(0.9)");
    if (state.brightness === 2) filters.push("brightness(1.05)");
    if (state.brightness === 3) filters.push("brightness(1.2)");

    if (state.saturation === 1) filters.push("saturate(0.85)");
    if (state.saturation === 2) filters.push("saturate(1.3)");
    if (state.saturation === 3) filters.push("saturate(0)");

    document.documentElement.style.setProperty("--ae-filter", filters.length ? filters.join(" ") : "none");
  }

  function applyZoomScrollFix(){
    const zoom = parseFloat(getComputedStyle(document.body).zoom || "1") || 1;
    const extra = Math.max(0, Math.round((zoom - 1) * window.innerHeight));
    document.body.style.paddingBottom = extra ? `${extra}px` : "";
  }

  // vh fix + widget counter-zoom
  function setVhVar(){
    document.documentElement.style.setProperty("--ae-vh", `${window.innerHeight * 0.01}px`);
  }
  function applyWidgetCounterZoom(){
  const pageZoom = [1, 1.1, 1.2, 1.3][state.biggerText] || 1;
  const inv = 1 / pageZoom;
  const invRounded = Math.round(inv * 1000) / 1000;

  widget.style.zoom = String(invRounded);

  // ✅ важно: сообщаем CSS текущий zoom виджета
  document.documentElement.style.setProperty("--ae-widget-zoom", String(invRounded));
}


  function applyText(){
    const zoom = [1, 1.1, 1.2, 1.3][state.biggerText] || 1;
    document.documentElement.style.setProperty("--ae-zoom", String(zoom));

    const ls = ["normal", "0.07em", "0.14em", "0.20em"][state.textSpacing] || "normal";
    document.documentElement.style.setProperty("--ae-letter-spacing", ls);

    const lh = ["normal", "1.75", "2.15", "2.65"][state.lineSpacing] || "normal";
    document.documentElement.style.setProperty("--ae-line-height", lh);

    const ta = ["initial", "left", "center", "right"][state.textAlign] || "initial";
    // Text Align: apply ONLY when user selected it (via html classes)
document.documentElement.classList.remove("ae-ta-left","ae-ta-center","ae-ta-right");
if (state.textAlign === 1) document.documentElement.classList.add("ae-ta-left");
if (state.textAlign === 2) document.documentElement.classList.add("ae-ta-center");
if (state.textAlign === 3) document.documentElement.classList.add("ae-ta-right");


    document.documentElement.classList.toggle("ae-dyslexia-font", !!state.dyslexiaFont);

    applyWidgetCounterZoom();
    setVhVar();
    requestAnimationFrame(applyZoomScrollFix);
  }

  function applyToggles(){
    document.documentElement.classList.toggle("ae-highlight-links", !!state.highlightLinks);
    document.documentElement.classList.toggle("ae-highlight-headings", !!state.highlightHeadings);
    document.documentElement.classList.toggle("ae-pause-anim", !!state.pauseAnimations);
    document.documentElement.classList.toggle("ae-hide-images", !!state.hideImages);
    document.documentElement.classList.toggle("ae-big-cursor", !!state.bigCursor);
  }

  // ---------- mute sounds ----------
  let mutedVideos = [];
  let mutedAudios = [];
  function applyMute(){
    const scope = document;
    if (state.muteSounds){
      mutedVideos = $$("video", scope).map(v => ({el:v, muted:v.muted, volume:v.volume}));
      mutedAudios = $$("audio", scope).map(a => ({el:a, muted:a.muted, volume:a.volume}));
      mutedVideos.forEach(x => { try{ x.el.muted = true; x.el.volume = 0; }catch(e){} });
      mutedAudios.forEach(x => { try{ x.el.muted = true; x.el.volume = 0; }catch(e){} });
    } else {
      mutedVideos.forEach(x => { try{ x.el.muted = x.muted; x.el.volume = x.volume; }catch(e){} });
      mutedAudios.forEach(x => { try{ x.el.muted = x.muted; x.el.volume = x.volume; }catch(e){} });
      mutedVideos = [];
      mutedAudios = [];
    }
  }

  // ---------- tooltips ----------
  function escapeHtml(str){
    return String(str)
      .replaceAll("&","&amp;")
      .replaceAll("<","&lt;")
      .replaceAll(">","&gt;")
      .replaceAll('"',"&quot;")
      .replaceAll("'","&#039;");
  }

  let lastPointer = {x: 0, y: 0};
  function showTooltip(html){
    if(!tooltip) return;
    tooltip.innerHTML = html;
    tooltip.hidden = false;
  }
  function hideTooltip(){
    if(!tooltip) return;
    tooltip.hidden = true;
  }
  function positionTooltipXY(x, y){
    if(!tooltip) return;
    const pad = 14;
    const w = tooltip.offsetWidth || 260;
    const h = tooltip.offsetHeight || 60;

    let xx = x + pad;
    let yy = y + pad;

    if (xx + w > window.innerWidth - 10) xx = x - w - pad;
    if (yy + h > window.innerHeight - 10) yy = y - h - pad;

    tooltip.style.left = `${xx}px`;
    tooltip.style.top = `${yy}px`;
  }

  function getAssociatedLabel(el){
    if (!el || !(el instanceof Element)) return "";
    const aria = el.getAttribute("aria-label");
    if (aria) return aria;
    const title = el.getAttribute("title");
    if (title) return title;

    const id = el.getAttribute("id");
    if (id){
      const lab = document.querySelector(`label[for="${CSS.escape(id)}"]`);
      if (lab && lab.textContent) return lab.textContent.trim();
    }

    const ph = el.getAttribute("placeholder");
    if (ph) return ph;

    const txt = (el.textContent || "").trim().replace(/\s+/g," ");
    if (txt) return txt.slice(0, 120);

    return "";
  }

  function getTooltipInfo(el){
    if (!el || !(el instanceof Element)) return null;
    if (el.closest && el.closest("#ae-widget")) return null;

    const tag = (el.tagName || "").toLowerCase();

    if (tag === "img"){
      const alt = el.getAttribute("alt") || "";
      return { tagName: "img", label: alt || "" };
    }

    if (["button","a","input","textarea","select"].includes(tag)){
      const label = getAssociatedLabel(el);
      return { tagName: tag, label: label || "" };
    }

    const role = (el.getAttribute("role") || "").toLowerCase();
    if (role === "button" || role === "link"){
      const label = getAssociatedLabel(el);
      return { tagName: role, label: label || "" };
    }

    return null;
  }

  function tooltipHandlers(){
    document.addEventListener("mouseover", (e)=>{
      if (!state.tooltips) return;
      const info = getTooltipInfo(e.target);
      if (!info) return;

      const lang = state.lang;
      const html = `
        <div class="ae-tt-title">${escapeHtml(i18n[lang].tt_title)}</div>
        <div class="ae-tt-sub">${escapeHtml(i18n[lang].tt_label)}: ${escapeHtml(info.label || "")}</div>
        <div class="ae-tt-sub">${escapeHtml(i18n[lang].tt_tag)}: ${escapeHtml(info.tagName)}</div>
      `;
      showTooltip(html);
      positionTooltipXY(lastPointer.x, lastPointer.y);
    }, true);

    document.addEventListener("mouseout", ()=>{
      if (!state.tooltips) return;
      hideTooltip();
    }, true);

    window.addEventListener("pointermove", (e)=>{
      lastPointer = {x: e.clientX, y: e.clientY};
      if (!state.tooltips || !tooltip || tooltip.hidden) return;
      positionTooltipXY(e.clientX, e.clientY);
    }, {passive:true});

    window.addEventListener("scroll", ()=>{
      if (!state.tooltips || !tooltip || tooltip.hidden) return;
      positionTooltipXY(lastPointer.x, lastPointer.y);
    }, {passive:true});
  }

  // ---------- Page Structure modal (NO FREEZE) ----------
  let cachedStructure = null;
  let building = false;

  function setCount(type, n){
    const el = $(`[data-count="${type}"]`);
    if (el) el.textContent = `(${n})`;
  }

  function collectStructure(){
    const body = document.body;

    const heads = $$("h1,h2,h3,h4,h5,h6", body).filter(x => !x.closest("#ae-widget"));
    const links = $$("a[href]", body).filter(x => !x.closest("#ae-widget"));

    const candidates = $$("[role], main, header, nav, footer, aside, section", body)
      .filter(x => !x.closest("#ae-widget"));

    const landmarks = candidates.filter(el=>{
      const tag = (el.tagName || "").toLowerCase();
      const role = (el.getAttribute("role") || "").toLowerCase();
      return ["main","header","nav","footer","aside"].includes(tag)
        || ["main","banner","navigation","contentinfo","complementary","search","region"].includes(role);
    });

    setCount("headings", heads.length);
    setCount("links", links.length);
    setCount("landmarks", landmarks.length);

    return {heads, links, landmarks};
  }

  function clearModalList(){
    if (modalList) modalList.innerHTML = "";
  }

  function renderChunk(items, renderer, startIndex, chunkSize){
    const end = Math.min(items.length, startIndex + chunkSize);
    for (let i = startIndex; i < end; i++){
      modalList.appendChild(renderer(items[i]));
    }
    if (end < items.length){
      requestAnimationFrame(()=>renderChunk(items, renderer, end, chunkSize));
    } else {
      building = false;
    }
  }

  function buildModalContent(tab){
    if(!modalList) return;
    if (building) return;
    building = true;

    clearModalList();

    if (!cachedStructure) cachedStructure = collectStructure();
    const {heads, links, landmarks} = cachedStructure;

    const makeItem = (tag, text, onClick) => {
      const item = document.createElement("div");
      item.className = "ae-item";
      item.innerHTML = `
        <div class="ae-item__tag">${escapeHtml(tag)}</div>
        <div class="ae-item__text">${escapeHtml(text || "(empty)")}</div>
      `;
      item.addEventListener("click", (e)=>{
        e.preventDefault();
        try{ onClick(); }catch(err){}
      });
      return item;
    };

    if (tab === "headings"){
      renderChunk(heads, (h)=>{
        const level = h.tagName.toUpperCase();
        const text = (h.textContent || "").trim().replace(/\s+/g," ").slice(0, 180);
        return makeItem(level, text || "(empty)", ()=>h.scrollIntoView({behavior:"smooth", block:"center"}));
      }, 0, 80);
      return;
    }

    if (tab === "landmarks"){
      renderChunk(landmarks, (el)=>{
        const role = ((el.getAttribute("role") || el.tagName) + "").toLowerCase();
        const label = (el.getAttribute("aria-label") || "").toString().trim();
        return makeItem(role, label || "(unlabeled)", ()=>el.scrollIntoView({behavior:"smooth", block:"center"}));
      }, 0, 80);
      return;
    }

    renderChunk(links, (a)=>{
      const text =
        (a.textContent || "").trim().replace(/\s+/g," ").slice(0, 140)
        || a.getAttribute("aria-label")
        || a.getAttribute("href")
        || "(empty)";
      return makeItem("A", text, ()=>a.scrollIntoView({behavior:"smooth", block:"center"}));
    }, 0, 80);
  }

  function setActiveTab(tab){
    $$(".ae-tab").forEach(btn=>{
      const is = btn.getAttribute("data-tab") === tab;
      btn.classList.toggle("is-active", is);
      btn.setAttribute("aria-selected", is ? "true" : "false");
    });
    buildModalContent(tab);
  }

  function openModal(){
    if(!modal) return;
    modal.hidden = false;
    cachedStructure = collectStructure();
    setActiveTab("headings");
  }

  function closeModal(){
    if(!modal) return;
    modal.hidden = true;
    cachedStructure = null;
    building = false;
    clearModalList();
  }

  let obsTimer = null;
  const mo = new MutationObserver((mutations)=>{
    if (!modal || modal.hidden) return;
    for (const m of mutations){
      const t = m.target;
      if (t && t.nodeType === 1 && t.closest && t.closest("#ae-widget")) return;
    }
    clearTimeout(obsTimer);
    obsTimer = setTimeout(()=>{
      cachedStructure = collectStructure();
    }, 250);
  });

  // ---------- Bionic Reading ----------
  const BIONIC_ATTR = "data-ae-bionic";
  let bionicOriginal = new Map();

  function bionicify(text){
    return text.replace(/([A-Za-zÀ-ÖØ-öø-ÿА-Яа-яЁё0-9]+)([^\s]*)/g, (m, word, tail)=>{
      const len = word.length;
      const cut = Math.max(1, Math.round(len * 0.4));
      const a = word.slice(0, cut);
      const b = word.slice(cut);
      return `<b>${escapeHtml(a)}</b>${escapeHtml(b)}${escapeHtml(tail||"")}`;
    });
  }

  function enableBionic(){
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode(node){
        if(!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        const p = node.parentElement;
        if(!p) return NodeFilter.FILTER_REJECT;
        if (p.closest("#ae-widget")) return NodeFilter.FILTER_REJECT;
        const tag = p.tagName.toLowerCase();
        if (["script","style","noscript"].includes(tag)) return NodeFilter.FILTER_REJECT;
        if (p.closest("input, textarea, select, button, a")) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    const nodes = [];
    while(walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach(node=>{
      const text = node.nodeValue;
      const span = document.createElement("span");
      span.setAttribute(BIONIC_ATTR, "1");
      span.innerHTML = bionicify(text);
      bionicOriginal.set(span, text);
      node.parentNode.replaceChild(span, node);
    });
  }

  function disableBionic(){
    $$(`[${BIONIC_ATTR}]`, document.body).forEach(span=>{
      const original = bionicOriginal.get(span);
      if (original != null) span.parentNode.replaceChild(document.createTextNode(original), span);
      else span.replaceWith(document.createTextNode(span.textContent || ""));
    });
    bionicOriginal.clear();
  }

  // ---------- Profiles (FIXED + persisted baseline) ----------
  function snapshotBaseline(){
    // baseline не должен содержать baseline внутри baseline
    const copy = {...state};
    copy.activeProfile = null;
    copy.baseline = null;
    return copy;
  }

  function ensureBaselineForProfile(){
    // если baseline уже есть — ок
    if (state.baseline && typeof state.baseline === "object") return;

    // если baseline нет, но профиль уже активен (пришёл со страницы/рефреша) —
    // создаём "разумный" baseline: текущие настройки БЕЗ профиля.
    // Самое безопасное: вернуть дефолт (иначе невозможно понять, что было "до профиля").
    // Это ключевой фикс, чтобы выключение профиля ВСЕГДА снимало его эффекты.
    const keepLang = state.lang;
    state.baseline = {...defaultState, lang: keepLang, baseline: null, activeProfile: null};
  }

  function restoreFromBaseline(){
    if (!state.baseline || typeof state.baseline !== "object") return;
    const keepLang = state.lang;
    const keepBaseline = state.baseline;
    state = {...keepBaseline};
    state.lang = keepLang;
    state.baseline = keepBaseline; // baseline сохраняем
  }

  const profileMap = {
    vision(){
      state.contrast = 2;
      state.biggerText = 2;
      state.highlightHeadings = true;
      state.bigCursor = true;
    },
    seizure(){
      state.contrast = 1;
      state.pauseAnimations = true;
      state.hideImages = true;
    },
    dyslexia(){
      state.textSpacing = 2;
      state.lineSpacing = 3;
      state.dyslexiaFont = true;
    },
    adhd(){
      state.pauseAnimations = true;
      state.bionicReading = true;
    },
    cognitive(){
      state.highlightLinks = true;
      state.highlightHeadings = true;
    }
  };

  function hardResetProfileEffects(){
    // bionic реально меняет DOM — чистим принудительно
    if (document.querySelector(`[${BIONIC_ATTR}]`)) {
      try { disableBionic(); } catch(e){}
    }
  }

  function setActiveProfile(next){
    // IMPORTANT: baseline должен существовать и при переходах между страницами
    ensureBaselineForProfile();

    // повторный клик по активному профилю = выключить профиль полностью
    if (state.activeProfile === next){
      hardResetProfileEffects();

      // возвращаем baseline
      restoreFromBaseline();

      // чистим профиль
      state.activeProfile = null;

      // baseline можно оставить (чтобы не потерять "точку до профиля" на этой странице),
      // но ты хочешь "снялось полностью" — оставим baseline, чтобы следующее включение снова работало корректно.
      // Если хочешь прям удалить baseline — можно state.baseline=null;
      saveState();
      applyAll();
      return;
    }

    // включаем новый профиль:
    // 1) если baseline ещё не был снят в этой сессии — снимаем ДО применения профиля
    // (но если baseline уже есть — не перезаписываем!)
    if (!state.baseline || typeof state.baseline !== "object"){
      state.baseline = snapshotBaseline();
    }

    // 2) откат в baseline (чтобы профили НЕ накладывались)
    hardResetProfileEffects();
    restoreFromBaseline();

    // 3) применяем новый профиль
    state.activeProfile = next;
    if (profileMap[next]) profileMap[next]();

    saveState();
    applyAll();
  }

  // ---------- actions ----------
  function toggleAction(action){
    switch(action){
      case "contrast":
        state.contrast = (state.contrast + 1) % 3;
        setBars("contrast", state.contrast === 0 ? 0 : state.contrast);
        setPressed($(`[data-action="contrast"]`), state.contrast !== 0);
        applyFilters();
        break;

      case "grayscale":
        state.grayscale = !state.grayscale;
        setPressed($(`[data-action="grayscale"]`), state.grayscale);
        applyFilters();
        break;

      case "invert":
        state.invert = !state.invert;
        setPressed($(`[data-action="invert"]`), state.invert);
        applyFilters();
        break;

      case "brightness":
        state.brightness = (state.brightness + 1) % 4;
        setBars("brightness", state.brightness);
        setPressed($(`[data-action="brightness"]`), state.brightness !== 0);
        applyFilters();
        break;

      case "saturation":
        state.saturation = (state.saturation + 1) % 4;
        setBars("saturation", state.saturation);
        setPressed($(`[data-action="saturation"]`), state.saturation !== 0);
        applyFilters();
        break;

      case "highlightLinks":
        state.highlightLinks = !state.highlightLinks;
        setPressed($(`[data-action="highlightLinks"]`), state.highlightLinks);
        applyToggles();
        break;

      case "pauseAnimations":
        state.pauseAnimations = !state.pauseAnimations;
        setPressed($(`[data-action="pauseAnimations"]`), state.pauseAnimations);
        applyToggles();
        break;

      case "hideImages":
        state.hideImages = !state.hideImages;
        setPressed($(`[data-action="hideImages"]`), state.hideImages);
        applyToggles();
        break;

      case "muteSounds":
        state.muteSounds = !state.muteSounds;
        setPressed($(`[data-action="muteSounds"]`), state.muteSounds);
        applyMute();
        break;

      case "biggerText":
        state.biggerText = (state.biggerText + 1) % 4;
        setBars("biggerText", state.biggerText);
        setPressed($(`[data-action="biggerText"]`), state.biggerText !== 0);
        applyText();
        break;

      case "textSpacing":
        state.textSpacing = (state.textSpacing + 1) % 4;
        setBars("textSpacing", state.textSpacing);
        setPressed($(`[data-action="textSpacing"]`), state.textSpacing !== 0);
        applyText();
        break;

      case "lineSpacing":
        state.lineSpacing = (state.lineSpacing + 1) % 4;
        setBars("lineSpacing", state.lineSpacing);
        setPressed($(`[data-action="lineSpacing"]`), state.lineSpacing !== 0);
        applyText();
        break;

      case "textAlign":
        state.textAlign = (state.textAlign + 1) % 4;
        setBars("textAlign", state.textAlign);
        setPressed($(`[data-action="textAlign"]`), state.textAlign !== 0);
        applyText();
        break;

      case "dyslexiaFont":
        state.dyslexiaFont = !state.dyslexiaFont;
        setPressed($(`[data-action="dyslexiaFont"]`), state.dyslexiaFont);
        applyText();
        break;

      case "bionicReading":
        state.bionicReading = !state.bionicReading;
        setPressed($(`[data-action="bionicReading"]`), state.bionicReading);
        if (state.bionicReading) enableBionic(); else disableBionic();
        break;

      case "highlightHeadings":
        state.highlightHeadings = !state.highlightHeadings;
        setPressed($(`[data-action="highlightHeadings"]`), state.highlightHeadings);
        applyToggles();
        break;

      case "pageStructure":
        openModal();
        break;

      case "bigCursor":
        state.bigCursor = !state.bigCursor;
        setPressed($(`[data-action="bigCursor"]`), state.bigCursor);
        applyToggles();
        break;

      case "tooltips":
        state.tooltips = !state.tooltips;
        setPressed($(`[data-action="tooltips"]`), state.tooltips);
        if (!state.tooltips) hideTooltip();
        break;

      default:
        return;
    }

    saveState();
  }

  // ---------- UI open/close ----------
  function openPanel(){
    widget.classList.add("is-open");
    panel.classList.add("is-open");
    panel.setAttribute("aria-hidden","false");
    if (dim){ dim.hidden = false; }
    fab.setAttribute("aria-expanded","true");
  }

  function closePanel(){
    widget.classList.remove("is-open");
    panel.classList.remove("is-open");
    panel.setAttribute("aria-hidden","true");
    if (dim){ dim.hidden = true; }
    fab.setAttribute("aria-expanded","false");

    if (langMenu){
      langMenu.classList.remove("is-open");
      langMenu.setAttribute("aria-hidden","true");
    }
    if (langBtn){
      langBtn.setAttribute("aria-expanded","false");
    }
  }

  function togglePanel(){
    if (panel.classList.contains("is-open")) closePanel();
    else openPanel();
  }

  // ---------- sync UI ----------
  function syncUI(){
    $$('[data-profile]').forEach(btn=>{
      const p = btn.getAttribute("data-profile");
      const on = state.activeProfile === p;
      setPressed(btn, on);
    });

    const actionStates = {
      grayscale: state.grayscale,
      invert: state.invert,
      highlightLinks: state.highlightLinks,
      pauseAnimations: state.pauseAnimations,
      hideImages: state.hideImages,
      muteSounds: state.muteSounds,
      dyslexiaFont: state.dyslexiaFont,
      bionicReading: state.bionicReading,
      highlightHeadings: state.highlightHeadings,
      bigCursor: state.bigCursor,
      tooltips: state.tooltips,
    };

    Object.entries(actionStates).forEach(([k,v])=>{
      setPressed($(`[data-action="${k}"]`), !!v);
    });

    setBars("contrast", state.contrast === 0 ? 0 : state.contrast);
    setPressed($(`[data-action="contrast"]`), state.contrast !== 0);

    setBars("brightness", state.brightness);
    setPressed($(`[data-action="brightness"]`), state.brightness !== 0);

    setBars("saturation", state.saturation);
    setPressed($(`[data-action="saturation"]`), state.saturation !== 0);

    setBars("biggerText", state.biggerText);
    setPressed($(`[data-action="biggerText"]`), state.biggerText !== 0);

    setBars("textSpacing", state.textSpacing);
    setPressed($(`[data-action="textSpacing"]`), state.textSpacing !== 0);

    setBars("lineSpacing", state.lineSpacing);
    setPressed($(`[data-action="lineSpacing"]`), state.lineSpacing !== 0);

    setBars("textAlign", state.textAlign);
    setPressed($(`[data-action="textAlign"]`), state.textAlign !== 0);

    applyI18n(state.lang);
  }

  function applyAll(){
    applyI18n(state.lang);
    applyFilters();
    applyText();
    applyToggles();
    applyMute();

    if (state.bionicReading){
      if (!document.querySelector(`[${BIONIC_ATTR}]`)) enableBionic();
    } else {
      if (document.querySelector(`[${BIONIC_ATTR}]`)) disableBionic();
    }

    syncUI();
  }

  // ---------- reset ----------
  function resetAll(){
    const keepLang = state.lang;
    state = {...defaultState, lang: keepLang};
    saveState();

    document.documentElement.classList.remove(
      "ae-highlight-links",
      "ae-highlight-headings",
      "ae-pause-anim",
      "ae-hide-images",
      "ae-big-cursor",
      "ae-dyslexia-font"
    );
    document.documentElement.style.setProperty("--ae-filter","none");
    document.documentElement.style.setProperty("--ae-zoom","1");
    document.documentElement.style.setProperty("--ae-letter-spacing","normal");
    document.documentElement.style.setProperty("--ae-line-height","normal");
    document.documentElement.style.setProperty("--ae-text-align","initial");
    document.body.style.paddingBottom = "";

    if (document.querySelector(`[${BIONIC_ATTR}]`)) disableBionic();

    state.muteSounds = false;
    applyMute();

    applyAll();
  }

  // ---------- language ----------
  function toggleLangMenu(){
    if(!langMenu || !langBtn) return;
    const open = langMenu.classList.toggle("is-open");
    langMenu.setAttribute("aria-hidden", open ? "false" : "true");
    langBtn.setAttribute("aria-expanded", open ? "true" : "false");
  }

  function setLang(lang){
    state.lang = (lang === "de") ? "de" : "en";
    saveState();
    applyI18n(state.lang);
  }

  // ---------- bind events ----------
  function bindEvents(){
    fab.addEventListener("click", (e)=>{
      e.preventDefault();
      togglePanel();
    });

    closeBtn && closeBtn.addEventListener("click", (e)=>{
      e.preventDefault();
      closePanel();
    });

    dim && dim.addEventListener("click", (e)=>{
      e.preventDefault();
      closePanel();
      closeModal();
    });

    document.addEventListener("keydown", (e)=>{
      if (e.key !== "Escape") return;

      if (langMenu && langMenu.classList.contains("is-open")){
        langMenu.classList.remove("is-open");
        langMenu.setAttribute("aria-hidden","true");
        langBtn && langBtn.setAttribute("aria-expanded","false");
        return;
      }

      if (modal && !modal.hidden){
        closeModal();
        return;
      }

      if (panel.classList.contains("is-open")){
        closePanel();
      }
    });

    langBtn && langBtn.addEventListener("click", (e)=>{
      e.preventDefault();
      toggleLangMenu();
    });

    document.addEventListener("click", (e)=>{
      if (!langMenu || !langBtn) return;
      const isOpen = langMenu.classList.contains("is-open");
      if (!isOpen) return;
      const t = e.target;
      if (t === langBtn || langBtn.contains(t)) return;
      if (t === langMenu || langMenu.contains(t)) return;
      langMenu.classList.remove("is-open");
      langMenu.setAttribute("aria-hidden","true");
      langBtn.setAttribute("aria-expanded","false");
    });

    $$(".ae-lang-opt", langMenu || document).forEach(btn=>{
      btn.addEventListener("click", (e)=>{
        e.preventDefault();
        const lang = btn.getAttribute("data-lang") || "en";
        setLang(lang);
        if (langMenu){
          langMenu.classList.remove("is-open");
          langMenu.setAttribute("aria-hidden","true");
        }
        if (langBtn) langBtn.setAttribute("aria-expanded","false");
      });
    });

    $$("[data-profile]").forEach(btn=>{
      btn.addEventListener("click", (e)=>{
        e.preventDefault();
        const p = btn.getAttribute("data-profile");
        if (!p) return;
        setActiveProfile(p);
      });
    });

    $$("[data-action]").forEach(btn=>{
      btn.addEventListener("click", (e)=>{
        e.preventDefault();
        const action = btn.getAttribute("data-action");
        if (!action) return;
        toggleAction(action);
      });
    });

    resetBtn && resetBtn.addEventListener("click", (e)=>{
      e.preventDefault();
      resetAll();
    });

    modalClose && modalClose.addEventListener("click", (e)=>{
      e.preventDefault();
      closeModal();
    });

    modal && modal.addEventListener("click", (e)=>{
      if (e.target === modal){
        closeModal();
      }
    });

    $$(".ae-tab").forEach(btn=>{
      btn.addEventListener("click", (e)=>{
        e.preventDefault();
        const tab = btn.getAttribute("data-tab");
        if (!tab) return;
        setActiveTab(tab);
      });
    });

    panel.addEventListener("wheel", (e)=>{
      if (!panel.classList.contains("is-open")) return;
      const scroller = $(".ae-panel__body", panel);
      if (!scroller) return;

      if (scroller.scrollHeight <= scroller.clientHeight + 1) return;

      const atTop = scroller.scrollTop <= 0;
      const atBottom = scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 1;

      if ((atTop && e.deltaY < 0) || (atBottom && e.deltaY > 0)){
        e.preventDefault();
      }
    }, {passive:false});

    tooltipHandlers();

    try{
      mo.observe(document.body, {subtree:true, childList:true, attributes:true});
    }catch(err){}

    window.addEventListener("resize", ()=>{
      setVhVar();
      applyWidgetCounterZoom();
      requestAnimationFrame(applyZoomScrollFix);

      if (state.tooltips && tooltip && !tooltip.hidden){
        positionTooltipXY(lastPointer.x, lastPointer.y);
      }
    }, {passive:true});
  }

  // ---------- init ----------
  function init(){
    ensureBars();

    if (langMenu){
      langMenu.setAttribute("aria-hidden","true");
      langMenu.classList.remove("is-open");
    }
    if (langBtn){
      langBtn.setAttribute("aria-expanded","false");
    }

    panel.setAttribute("aria-hidden", panel.classList.contains("is-open") ? "false" : "true");
    fab.setAttribute("aria-expanded", panel.classList.contains("is-open") ? "true" : "false");

    setVhVar();
    applyWidgetCounterZoom();

    applyAll();
    bindEvents();
    document.documentElement.classList.add("ae-ready");

  }

  init();
})();
